import './index.scss';
import React, { useMemo } from 'react';

import MetricCardContext from '../MetricCardContext';
import TipContext from '@/pages/home/components/TipContextComponents/TipContext';

// import { useIntl } from 'umi';
import { ICardConfig, ICardContentProp, TMetric } from '../../type';
import { TPlatformType, TSourceType } from './type';
import { getLocale, useIntl } from 'umi';
import NoData from '@intelligence/components/NoData';

export interface IPlatformCardProps {
  datas: ICardConfig[];
  needCustomIcon?: boolean;
  icon?: TSourceType | TPlatformType | string;
}

// PlatformCard
export default function PlatformCard(props: IPlatformCardProps) {
  const { datas, needCustomIcon, icon } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();

  const metricKeyMap: Record<TMetric, string> = useMemo(
    () => ({
      revenue: formatMessage({ id: 'dbi_revenue_$' }),
      download: formatMessage({ id: 'dbi_downloads' }),
      game_count: formatMessage({ id: 'dbi_market_total_game' }),
    }),
    [locale, formatMessage],
  );

  const itemMessageFormatter = (list?: ICardContentProp[]) => {
    const newList = list?.map((child) => {
      const label = child?.label as TMetric;
      if (label in metricKeyMap) {
        return {
          ...child,
          label: metricKeyMap[label],
        };
      }

      return child;
    });

    return newList;
  };

  return datas?.length > 0 ? (
    <>
      {datas.map((card, idx) => {
        const iconSrc = needCustomIcon && icon ? icon : card?.icon;
        // const platformNameArr = card?.label?.split(',')?.map((key) => formatMessage({ id: key }));
        const platformNameArr = card?.label
          ?.split(',')
          ?.map((key, idx) => (idx === 0 ? formatMessage({ id: key }) : key));

        const platformName = platformNameArr?.join(' ');

        return (
          <div key={`${card.label}-${idx}`} className="adi-marketprofile-cardcont">
            <div className="cardcont-head">
              {iconSrc ? <img src={iconSrc} alt="" /> : ''}
              {/* {card?.label ? <span>{formatMessage({ id: card?.label })}</span> : ''} */}
              {platformName ? <span>{platformName}</span> : ''}
              {card?.msg ? (
                <TipContext
                  className="cardcont-head-tip"
                  tipText={formatMessage({ id: card?.msg })}
                />
              ) : (
                ''
              )}
            </div>
            <div className="card-cont-wrap">
              <MetricCardContext data={itemMessageFormatter(card?.children)} />
            </div>
          </div>
        );
      })}
    </>
  ) : (
    <NoData />
  );
}
